import { ContactsPhoneWUT } from '@wix/form-fields/wut';

export default ContactsPhoneWUT;
